import React, {useState, useEffect} from "react";
import MetaTags from 'react-meta-tags';
import { Container, Row, Col, CardBody, Card, Button, Form, Label, Input, FormFeedback } from "reactstrap";
import logoImg from "assets/images/bridge-logo.png";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import toastr from "toastr";
import axios from "axios";
import { TOAST_OPTIONS1, HRConfig2 } from "helpers/backend_helper";
import * as url from "helpers/apache_url";

const ChangePassword = () => {
    const history = useHistory()
    toastr.options = TOAST_OPTIONS1;
    const [userId, setUserId] = useState("")
    const [staffno, setStaffNo] = useState("")
    const [empName, setEmpName] = useState("")
    const [oldPass, setOldPass] = useState("")
    const [newPass, setNewPass] = useState("")
    const [newPass1, setNewPass1] = useState("")
    
    useEffect(()=>{
        if (localStorage.getItem("authMildUser")) {
            const obj = JSON.parse(localStorage.getItem("authMildUser"));
            setUserId(obj.uid)
            setEmpName(obj.username)
        }
    },[])
 
    const handleSubmit = () =>{
        if(oldPass.trim().length < 4){
            toastr.error("Please enter Old Password")
        }else if(staffno.trim().length < 2){
          toastr.error("Fill in the employee staff number!")
        }else if((newPass.trim().length < 8) || (newPass1.trim().length < 8)){
            toastr.error("New Password should be minimum 8 characters")
        }else if(newPass != newPass1){
            toastr.error("Please Confirm the new password")
        }else{
            const data = {
                userId     : staffno,
                oldPassword: oldPass,
                password   : newPass,
                cPassword  : newPass1
            }
            axios.post(url.CHANGEPASSWORD, JSON.stringify(data), HRConfig2).then((r)=>{
                console.log(r.data)
                if(r.data.status == '0'){
                    toastr.error(r.data.message)
                }else{
                    toastr.success(r.data.message)
                    history.push("/login")
                }
            }).catch((e)=>{
                console.log(e)
            })
            
        }
    }

  return (
    <React.Fragment>
    <MetaTags>
      <title>Change Password | BRIDGE</title>
    </MetaTags>
    <div className="home-btn d-none d-sm-block">
      <Link to="/" className="text-dark">
        <i className="fas fa-home h2" />
      </Link>
    </div>
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="overflow-hidden">
              <div className=" bg-soft">
                <Row>
    
                  <Col xs={12}>
                    <div className="text-primary p-4">
                    <img src={logoImg} alt="" className="img-fluid" height="60" />
                  
                    </div>
                  </Col>
                  
                </Row>
              </div>
              
              <CardBody className="pt-0">
               
                <div className="p-2">
                <div className="alert alert-success text-center mb-4" role="alert">Change Password for user <b>{empName}</b></div>

                    <div className="mb-3">
                      <Label className="form-label">Staff Number</Label>
                      <Input className="form-control" type="text" onChange={(e)=>setStaffNo(e.target.value)} />
                    </div>
                    
                    <div className="mb-3">
                      <Label className="form-label">Old Password</Label>
                      <Input className="form-control" type="password" onChange={(e)=>setOldPass(e.target.value)} />
                    </div>

                    <div className="mb-3">
                      <Label className="form-label">New Password</Label>
                      <Input className="form-control" type="password" onChange={(e)=>setNewPass(e.target.value)}/>
                    </div>
                    
                    <div className="mb-3">
                      <Label className="form-label">Confirm New Password</Label>
                      <Input className="form-control" type="password" onChange={(e)=>setNewPass1(e.target.value)} />
                    </div>
                    <div className="mt-4">
                      <button
                        className="btn btn-primary btn-block "
                        type="button"
                        onClick={()=>handleSubmit()}
                      >
                        Save
                      </button>
                    </div>
                </div>
                <div className="mt-5 text-center">

            </div>
              </CardBody>
            </Card>
           
          </Col>
        </Row>
      </Container>
    </div>
  </React.Fragment>
);

};
export default ChangePassword;
